import { render } from "./CidModal.vue?vue&type=template&id=588b7ed1"
import script from "./CidModal.vue?vue&type=script&lang=js"
export * from "./CidModal.vue?vue&type=script&lang=js"

import "./CidModal.vue?vue&type=style&index=0&id=588b7ed1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__